/* eslint-disable no-unused-vars */
import mixpanel from "mixpanel-browser";

declare module "mixpanel-browser" {
  interface Config {
    record_sessions_percent: number;
  }
}

interface IMixpanelUser{
  email?: string;
  phone?: string;
  first_name?: string;
  last_name?: string;
}
export function userActivityLogger(eventName: string, eventData: {}, user?: IMixpanelUser) {
  const userStoredInLocalStorage = JSON.parse(localStorage.getItem("persistantState")!)?.user?.user;


  mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_ID!, {
    debug: false,
    persistence: "localStorage",
    ignore_dnt: true,
    api_host: process.env.REACT_APP_PROXY_SERVER,
    record_sessions_percent: 50,
  });
  // Set identity for each user
  let location;
  let msa;

  if (userStoredInLocalStorage?.firstName && userStoredInLocalStorage?.lastName&& userStoredInLocalStorage?.email) {
    const firstName=userStoredInLocalStorage?.firstName;
    const lastName=userStoredInLocalStorage?.lastName;
    const email=userStoredInLocalStorage?.email;
    const phone=userStoredInLocalStorage?.phone;

    msa=userStoredInLocalStorage?.location?.city;
    location=userStoredInLocalStorage?.location?.locationName;
    mixpanel.identify(email);
    mixpanel.people.set({
      $first_name: firstName,
      $last_name: lastName,
      $mobile_number: phone,
    });
  } else if (user?.email|| user?.phone) {
    mixpanel.identify(user.email||user.phone);
    if (user.first_name && user.last_name) {
      mixpanel.people.set({
        $first_name: user?.first_name,
        $last_name: user?.last_name,
        $mobile_number: user?.phone,
      });
    }
  }

  mixpanel.track(eventName, { msa, location, ...eventData, "platform": "Web-app", "email": user?.email });
}
